var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-button",style:({
    background: `#${_vm.hexColor}`,
  }),on:{"click":_vm.performClick}},[_c('p',{staticClass:"text-button-text uppercase"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }